import SLSImagemHomeClient from '@/api/SistemaDKP/sls-imagem-home.client';
import store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import S3BucketService from '@/services/s3-bucket.service';
import Notifier from '@/libs/Notifier';

export default class SLSImagemHomeService {
  constructor() {
    this.client = new SLSImagemHomeClient();
    this.clientMarca = new EsMarcaClient();
    this.store = store;
    this.s3BucketService = new S3BucketService();
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getImagemHome(this.store.getters['slsImagemHome/getFilters']);
      this.store.commit('slsImagemHome/setImagensHome', data);
      this.store.commit('slsImagemHome/setFilters', pagination);
    } catch (error) {
      console.log(error);
    }
  }

  async findById(id) {
    try {
      const data = await this.client.getImagemHomeById(id);
      this.store.commit('slsImagemHome/setCurrentImagemHome', data);
    } catch (error) {
      console.log(error);
    }
  }

  async findAllMarcars() {
    try {
      const { data, ...pagination } = await this.clientMarca.getEsMarca({
        page: 1,
        perPage: 100,
      });
      this.store.commit('slsImagemHome/setOptionsMarcas', data);
    } catch (error) {
      console.log(error);
    }
  }

  async save(imagemHome) {
    this.store.commit('slsImagemHome/setIsLoading', true);
    try {
      const formatData = new FormData();

      formatData.append('caminho_catalogo', imagemHome.caminho_catalogo);
      formatData.append('caminho', imagemHome.caminho);
      formatData.append('caminho_img_cabec_marcas', imagemHome.caminho_img_cabec_marcas);
      formatData.append('caminho_img_footer_principal', imagemHome.caminho_img_footer_principal);
      formatData.append('caminho_img_footer_secundaria', imagemHome.caminho_img_footer_secundaria);
      formatData.set('cod_marca', imagemHome.cod_marca);
      formatData.set('ordem_visualizacao', imagemHome.ordem_visualizacao);
      formatData.set('cor_cabecalho_marca', imagemHome.cor_cabecalho_marca);

      const { data } = await this.client.postImagemHome(formatData);
      this.store.commit('slsImagemHome/addOfUpdateImagemHome', data);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsImagemHome/setIsLoading', false);
    }
  }

  async update(imagemHome) {
    this.store.commit('slsImagemHome/setIsLoading', true);
    if (!this.store.getters['slsImagemHome/getIsAlteracao']) {
      this.notify.info('Nenhuma alteração foi realizada');
      this.store.commit('slsImagemHome/setIsLoading', false);
      return;
    }
    try {
      const formatData = new FormData();

      formatData.append('caminho_catalogo', imagemHome.caminho_catalogo);
      formatData.append('caminho', imagemHome.caminho);
      formatData.append('caminho_img_cabec_marcas', imagemHome.caminho_img_cabec_marcas);
      formatData.append('caminho_img_footer_principal', imagemHome.caminho_img_footer_principal);
      formatData.append('caminho_img_footer_secundaria', imagemHome.caminho_img_footer_secundaria);
      formatData.set('cod_marca', imagemHome.cod_marca);
      formatData.set('ordem_visualizacao', imagemHome.ordem_visualizacao);
      formatData.set('cor_cabecalho_marca', imagemHome.cor_cabecalho_marca);

      const { data } = await this.client.putImagemHome(imagemHome.log_img_id, formatData);
      this.store.commit('slsImagemHome/addOfUpdateImagemHome', data);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsImagemHome/setIsLoading', false);
    }
  }

  async delete(id) {
    this.store.commit('slsImagemHome/setIsLoading', true);
    try {
      const { data } = await this.client.deleteImagemHome(id);
      this.store.commit('slsImagemHome/deleteImagemHome', id);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsImagemHome/setIsLoading', false);
    }
  }
}
